import React from "react";
import { Outlet, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { getCategoryByKey } from "../api/api";
import "../styles/DashboardLayout.css";

export default function DashboardLayout() {
  const { categoryKey } = useParams();
  const category = getCategoryByKey(categoryKey);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="layout-main">
        <Navbar
          title={category ? category.label : "Dashboard"}
          onMenuClick={() => setSidebarOpen(true)}
        />
        <main className="layout-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
